import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../_hooks/useDialogLauncher';

PendingBanner.propTypes = {
  offer: PropTypes.object.isRequired,
  claim: PropTypes.object.isRequired
};

export default function PendingBanner(props) {
  const { offer, claim, creator } = props;

  const launch = useDialogLauncher();

  function showInterestedDialog() {
    launch(DialogManager.ClaimConnect.Config(claim.id));
  }

  function showDeclineDialog() {
    launch(DialogManager.ClaimDecline.Config(claim.id));
  }

  return (
    <Wrapper
      color="yellow"
      creator={creator}
      title={(
        <>
          {creator.data.firstName} invited you! Are you interested in this offer?
        </>
      )}
      subtitle={(
        <>
          Connect with {creator.data.firstName} to share your interest. You can ask questions,
          provide ideas, or share insights on how this offer could support you and others.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={showDeclineDialog}>
          Sorry, this doesn't work for me
        </ConnectButton>
        <ConnectButton color="yellow" onClick={showInterestedDialog}>
          I'm interested
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
